// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-monitoring {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
}

.subtitle {
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
}

.controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
}

.search-field {
    width: 300px;
}

.create-buttons {
    display: flex;
    gap: 10px;
}

.create-button {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    font-weight: 600;
    border-radius: 4px;
}

    .create-button i {
        margin-right: 8px;
    }

    .create-button.p-button-secondary {
        background-color: white;
        border-color: #d1d5db;
        color: #0F3443;
    }

        .create-button.p-button-secondary:hover {
            background-color: #f3f4f6;
        }

    .create-button.p-button-primary {
        background-color: #38EF7D;
        border-color: #38EF7D;
        color: #0F3443;
    }

        .create-button.p-button-primary:hover {
            background-color: #32d56f;
        }

.app-name {
    font-weight: 500;
}

.app-id {
    font-size: 12px;
    color: #666;
}

:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
    background-color: #f8f9fa;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #f8f9fa;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
    background-color: #e9ecef;
}

@media screen and (max-width: 768px) {
    .controls {
        flex-direction: column;
        align-items: stretch;
    }

    .search-field {
        width: 100%;
        margin-bottom: 10px;
    }

    .create-buttons {
        flex-direction: column;
    }

    .create-button {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pages/app-monitoring.page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;QACrB,cAAc;IAClB;;QAEI;YACI,yBAAyB;QAC7B;;IAEJ;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;IAClB;;QAEI;YACI,yBAAyB;QAC7B;;AAER;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".app-monitoring {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 8px;\n}\n\n.subtitle {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 24px;\n}\n\n.controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 48px;\n}\n\n.search-field {\n    width: 300px;\n}\n\n.create-buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.create-button {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 16px;\n    font-weight: 600;\n    border-radius: 4px;\n}\n\n    .create-button i {\n        margin-right: 8px;\n    }\n\n    .create-button.p-button-secondary {\n        background-color: white;\n        border-color: #d1d5db;\n        color: #0F3443;\n    }\n\n        .create-button.p-button-secondary:hover {\n            background-color: #f3f4f6;\n        }\n\n    .create-button.p-button-primary {\n        background-color: #38EF7D;\n        border-color: #38EF7D;\n        color: #0F3443;\n    }\n\n        .create-button.p-button-primary:hover {\n            background-color: #32d56f;\n        }\n\n.app-name {\n    font-weight: 500;\n}\n\n.app-id {\n    font-size: 12px;\n    color: #666;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n    background-color: #f8f9fa;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr:nth-child(even) {\n    background-color: #f8f9fa;\n}\n\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {\n    background-color: #e9ecef;\n}\n\n@media screen and (max-width: 768px) {\n    .controls {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .search-field {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n\n    .create-buttons {\n        flex-direction: column;\n    }\n\n    .create-button {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
